<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="backgroung-title container-fluid row p-0 px-3 py-4 m-0" style="display: flex; flex-direction: column">
    <!-- SECTION -->
    @if (periods) {
    <app-situation class="px-0" [typeSituacion]="periodsType"
      [arrayPeriodosHist]="periodsType === 'situation' ? arrayPeriodosHist:tempPeriods.newHistory"
      [variants]="tempPeriodsVariant" [iCanRegistros]="iCanRegistros" [changeSituation]="changeSituation"
      [changePeriods]="changePeriods" [isEditing]="isEditing" (setPeriods)="setPeriodsCurrent($event)"
      (setAllPeriods)="setAllPeriods($event)" (setSituation)="setSituation($event)">
    </app-situation>
    }


    @if (avaibleSource(SUB_DOMAIN_JO)) {
    <ng-container style="display: flex; flex-direction: column">
      @for (section of sectionArray | keyvalue; track section.key; let sectionIndex = $index) {
      <div class="efx-row-datasource source_item" [ngStyle]="getSectionOrder(section.key)">
        <div [ngClass]="{'d-flex justify-content-between':periods}">
          <div class="efx-row-title item_title">
            {{ section.key }}
            @if (periods && periodsSection.toUpperCase() !== '' && periodsSection.toUpperCase() ===
            String(section.key).toUpperCase()) {
            /
            {{tempPeriods.periodsCurrent}}
            }
            <div class="w-123"></div>

          </div>
          @if (periods) {
          @if (periodsSection.toUpperCase() !== '' && periodsSection.toUpperCase() ===
          String(section.key).toUpperCase()) {
          <div class="d-flex">
            <div class="prev" (click)="previousPeriods()">
              <em class="fa fa-angle-double-left fs-20px"
                [ngClass]="{'btn-periods-disabled':tempPeriods.periodsCurrent === tempPeriods.periodsMax,'btn-periods-active':tempPeriods.periodsCurrent !== tempPeriods.periodsMax}"></em>
            </div>
            <div class="next" style="margin-left: 30px;" (click)="nextPeriods()">
              <em class="fa fa-angle-double-right fs-20px"
                [ngClass]="{'btn-periods-disabled':tempPeriods.periodsCurrent === tempPeriods.periodsMin,'btn-periods-active':tempPeriods.periodsCurrent !== tempPeriods.periodsMin}"></em>
            </div>
          </div>
          }
          }
        </div>
        <div class="row">
          @for (item of section.value; track item) {
          <ng-container style="display: flex">
            @let tempItem = getItemData(item);
            @let tempValidatorsValues = getTempValidatorsValues(tempItem?.validators);
            <!-- edit mode type text or bool -->
            <div class="mb-2" [ngClass]="getColumnClass(tempItem)">
              <!-- <div class="mb-2"
                    [ngClass]="{'col-lg-12':(tempItem.inputType === 'textarea' || tempItem.inputType === 'array') && columnGripNumber(tempItem.value,tempItem.inputType) === 12,'col-lg-9':columnGripNumber(tempItem.value) === 9,'col-lg-6':columnGripNumber(tempItem.value) === 6,'col-lg-3':columnGripNumber(tempItem.value) === 3}"> -->
              @if (tempItem.inputType !== 'array') {
              <label class="efx-label title" [for]="tempItem.name">
                {{ tempItem.label }}
                @if (tempItem.nullable === false) {
                <span class="required"></span>
                }
              </label>
              }
              @if (
              isFieldEditable(isEditing, isAdding, tempItem)) {
              @if ((tempItem.inputType === 'text' ||
              tempItem.inputType === 'number' ||
              tempItem.inputType === 'bool' ||
              tempItem.inputType === 'boolean' ||
              tempItem.inputType === 'email')) {
              <div>
                <input class="form-control efx-input" editingBorder
                  [formControlName]="tempItem.name" [id]="tempItem.name" [name]="tempItem.name"
                  [min]="tempValidatorsValues.min" [max]="tempValidatorsValues.max"
                  [minlength]="tempValidatorsValues.minlength"
                  [ngClass]="{ 'is-invalid': showInvalidBorder(form, tempItem), 'history-diff': isFieldFromHistory(tempItem.name) }"
                  [type]="tempItem.inputType" (input)="inputValidator($event)"
                  (change)="changeDependency($event.target.name)" />
              </div>
              }
              @if ((
              tempItem.inputType === 'checkbox' ||
              tempItem.inputType === 'select' ||
              tempItem.inputType === 'template'
              )) {
               <div
                 class="w-100"
                 [class.gfd-dropdown-invalid-wrapper]="isDropdownInvalid(tempItem)"
                 [style.border]="isDropdownInvalid(tempItem) ? '2px solid #dc3545' : null"
                 [style.border-radius]="isDropdownInvalid(tempItem) ? '4px' : null">
                 <efx-dropdown
                   #gfdDropdown
                   class="gfd-efx-dropdown d-block w-100"
                   [class.gfd-dropdown-invalid]="isDropdownInvalid(tempItem)"
                   [controlId]="tempItem.name"
                   [controlName]="tempItem.name"
                   [name]="tempItem.name"
                   [id]="tempItem.name"
                   [formGroup]="form"
                   [options]="getDropdownOptions(tempItem)"
                   [selectedId]="getDropdownSelectedId(tempItem)"
                   bindId="id"
                   bindDescription="description"
                   [fullWidth]="true"
                   [placeholder]="'Seleccione una opción'"
                   [isRequired]="tempItem.nullable === false"
                   [isSearchable]="tempItem.isSearchable ?? false"
                   [isMultiSelect]="tempItem.isMultiSelect ?? false"
                   [showPills]="tempItem.isMultiSelect ?? false"
                   [suggestAfterChars]="0"
                   [searchPlaceholder]="'Buscar...'"
                   (onChange)="onDynamicDropdownChange(tempItem, $event)"
                   (onChangeMultiple)="onDynamicDropdownMultiChange(tempItem, $event)">
                 </efx-dropdown>
               </div>
              }
              @if (tempItem.inputType === 'textarea') {
              <div>
                <textarea rows="8" cols="100" class="col-lg-12" editingBorder autocapitalize="none" #inputEdit
                  [formControlName]="tempItem.name" [id]="tempItem.name" [name]="tempItem.name"
                  [ngClass]="{ 'is-invalid': showInvalidBorder(form, tempItem), 'history-diff': isFieldFromHistory(tempItem.name) }"
                  type="text" (input)="inputValidator($event)"
                  (change)="changeDependency($event.target.name)"></textarea>
              </div>
              }
              @if (tempItem.inputType === 'date') {
              <div>
                <input class="form-control efx-input" [formControlName]="tempItem.name" [id]="tempItem.name"
                  [min]="getDateMinLimit(tempItem)"
                  [max]="getDateMaxLimit(tempItem)"
                  [name]="tempItem.name" [ngClass]="{
                      'is-invalid': showInvalidBorder(form, tempItem),
                      'history-diff': isFieldFromHistory(tempItem.name)
                    }" type="{{(tempItem.pattern === 'YYYYMM' || tempItem.pattern === 'YYYY-MM')? 'month':'date'}}"
                  (change)="changeDependency($event.target.name)" />
              </div>
              }
              @if (tempItem.inputType === 'time') {
              <div class="wrapper_date" style="display: flex">
                <input class="form-control efx-input" [formControlName]="tempItem.name" [id]="tempItem.name"
                  [name]="tempItem.name" type="time" [(ngModel)]="time" editingBorder [valueEditing]="inputEdit.value"
                  [ngClass]="{ 'history-diff': isFieldFromHistory(tempItem.name) }" #inputEdit
                  (change)="changeDependency($event.target.name)" />
              </div>
              }
              @if (tempItem.inputType === 'map') {
              <div class="map-field map-field--edit">

                <!-- <div class="d-flex justify-content-between align-items-center">
                  <div class="map-field__toolbar">
                    <span class="map-field__badge">Key / Value</span>
                    @if (getMapEntriesCount(tempItem.name, true) > 0) {
                    <span class="map-field__badge map-field__badge--muted">
                      {{ getMapEntriesCount(tempItem.name, true) }} Atributos
                    </span>
                    }
                  </div>

                  <div>
                    <div class="map-editor__actions">
                      <button class="efx-button-primary" type="button" (click)="addMapEntry(tempItem.name)" efxTooltip
                        efxTooltipTitle="Agregar par" efxTooltipPlacement="bottom" efxTooltipMode="dark">
                        <span class="material-symbols-outlined">add</span>
                      </button>
                    </div>
                  </div>
                </div> -->

                <div class="map-editor">
                  @for (entryGroup of getMapEditorControls(tempItem.name); track $index; let index = $index) {
                  <div class="map-editor__row d-block d-lg-flex" [formGroup]="entryGroup">
                    <input class="h-46px form-control efx-input map-editor__input mb-3 mb-lg-0" formControlName="key" placeholder="Clave"
                      (input)="syncMapControl(tempItem.name)" />
                    <input class="h-46px form-control efx-input map-editor__input mb-3 mb-lg-0" formControlName="value" placeholder="Valor"
                      (input)="syncMapControl(tempItem.name)" />
                    <!-- <button class="efx-button-danger map-editor__remove mb-3 mb-lg-0" type="button"
                      (click)="removeMapEntry(tempItem.name, index)" efxTooltip efxTooltipTitle="Eliminar par"
                      efxTooltipPlacement="bottom" efxTooltipMode="dark">
                      <span class="material-symbols-outlined">delete</span>
                    </button> -->
                  </div>
                  }
                </div>


                @if (form.get(tempItem.name)?.errors?.['invalidMapEntries']) {
                <span class="text-danger">No puede haber claves vacÃ­as con valor ni claves repetidas.</span>
                }

              </div>
              }
              @if (showValidatorsInitial(tempItem)) {
              @for (error of tempItem.validators; track error.type) {
              <div>
                @if (showValidators(form, tempItem, error)) {
                <span class="text-danger">{{error.msg}}</span>
                }
              </div>
              }
              }
              } @else {
              <div>
                <span class="col fx-row-input-title p-0">
                  @if (
                  !((isEditing || isAdding) && tempItem.editable) &&
                  (tempItem.inputType === 'checkbox' ||
                  tempItem.inputType === 'boolean' ||
                  tempItem.inputType === 'select')
                  ) {
                  <p class="efx-row-input-data text-break">
                    {{
                    mostrarDataSelect(tempItem.value, tempItem.name, item.editable) || "-"
                    }}
                  </p>
                  }
                  @if (
                  !((isEditing || isAdding) && tempItem.editable) &&
                  tempItem.inputType === 'map'
                  ) {
                  @if (getMapEntries(tempItem.name).length > 0) {
                  <div class="map-preview map-preview--readonly">
                    <div class="map-preview__title">{{ getMapEntriesCount(tempItem.name) }} pares cargados</div>
                    <div class="map-preview__list">
                      @for (entry of getMapEntries(tempItem.name); track entry.key) {
                      <div class="map-preview__row">
                        <span class="map-preview__key">{{ entry.key }}</span>
                        <span class="map-preview__value">{{ entry.value }}</span>
                      </div>
                      }
                    </div>
                  </div>
                  } @else {
                  <p class="efx-row-input-data text-break">-</p>
                  }
                  }
                  @if (
                  !((isEditing || isAdding) && tempItem.editable) &&
                  !(
                  tempItem.inputType === 'checkbox' ||
                  tempItem.inputType === 'boolean' ||
                  tempItem.inputType === 'select' ||
                  tempItem.inputType === 'array' ||
                  tempItem.inputType === 'map'
                  )
                  ) {
                  <p class="efx-row-input-data text-break">
                    {{ mostrarDataText(tempItem.name, tempItem.inputType, tempItem.editable ) }}
                  </p>
                  }
                </span>
              </div>
              }
            </div>
            <!-- template -->
            @if ( (isEditing || isAdding) &&
            (tempItem.editable && tempItem.inputType === 'template' && buttonAdd)) {
            <app-template [data]="templateInput" (returnDataTemplate)="setDataTemplate($event)"></app-template>
            }
            @if (tempItem.inputType==='array' && tempItem.subFields && tempItem.subFields.length > 0) {
            {{addIndexItemArray(tempItem.name,sectionIndex)}}
            @if (!(isEditing || isAdding) && (tempItem.editable || tempItem.visible)) {
            <div class="d-block col-lg-12">
              <div class="d-block w-100 table-res">
                <table class="w-100" mat-table [dataSource]="tempArray[tempItem.name].dataSource"
                  aria-label="array mode">
                  @for (column of tempArray[tempItem.name].columns; track column.name) {
                  <ng-container matColumnDef="{{column.name}}">
                    <th class="p-3" mat-header-cell *matHeaderCellDef>{{column.label}}</th>
                    <td class="px-3 py-2" mat-cell *matCellDef="let element"> {{element[column.name]}} </td>
                  </ng-container>
                  }
                  <tr mat-header-row *matHeaderRowDef="tempArray[tempItem.name].displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: tempArray[tempItem.name].displayedColumns"></tr>
                </table>
              </div>
            </div>
            }
            @if ((isEditing || isAdding) && tempItem.editable) {
            <div>
              <div class="w-100">
                <div class="d-flex justify-content-end my-3">
                  <button class="efx-button-primary" type="button" (click)="addControlArrayObject(sectionIndex)"
                    efxTooltip efxTooltipTitle="Agregar" efxTooltipPlacement="bottom" efxTooltipMode="dark">
                    <span class="material-symbols-outlined">add</span>
                  </button>
                </div>
              </div>
              <div class="max-h-600px overflow-y" [formArrayName]="tempItem.name" [id]="tempItem.name"
                [name]="tempItem.name">
                @for (element of getControl(tempItem.name,form).controls; track $index; let i = $index; let last =
                $last) {
                <div>
                  <div class="row" [formGroupName]="i">
                    @for (temp of tempArray[tempItem.name].columns; track temp.name) {
                    <div class="col-lg-3">
                      <div>
                        <span class="title">{{temp.label}}</span>
                        @if (temp.editable) {
                        <input class="form-control efx-input" [formControlName]="temp.name" [id]="temp.name"
                          [name]="temp.name" type="text" />
                        } @else {
                        <input class="form-control efx-input" [formControlName]="temp.name" [id]="temp.name"
                          [name]="temp.name" type="text" disabled="false" />
                        }
                      </div>
                    </div>
                    }
                    <div class="col-lg-3 d-flex align-items-end py-1" (click)="onRemoveItemFormArray(i,sectionIndex)">
                      <button class="efx-button-danger" type="button" efxTooltip efxTooltipTitle="Eliminar"
                        efxTooltipPlacement="bottom" efxTooltipMode="dark">
                        <span class="material-symbols-outlined">delete</span>
                      </button>
                    </div>
                  </div>
                  @if (!last) {
                  <hr>
                  } @else {
                  <br>
                  }
                </div>
                }
              </div>
            </div>
            }
            }
          </ng-container>
          }
        </div>
      </div>
      }
    </ng-container>
    }
  </div>
</form>
<!-- END MATRIZ DATOS -->
<efx-modal [(show)]="showModal" [size]="modalSize.medium" [showFooter]="true" [showSubmit]="true" [showClose]="true"
  submitLabel="Cerrar" title=" " (submit)="redireccionBuscador()" (onHide)="showModal = false"
  (cancel)="showModal = false">
  <div class="d-flex flex-column align-items-center">
    <section class="m-0 text-center mt-3">
      <p class="m-0" style="font-size: 1.5rem;"><strong [innerHTML]="tituloModal"></strong></p> <br>
      <p class="m-0" [innerHTML]="bodyModal"></p>
    </section>
  </div>
</efx-modal>
